const trimTrailingSlash = (value) => value.replace(/\/$/, "");

export const PUBLIC_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_PUBLIC_ORIGIN || "https://itruck.io",
);

export const OPERATOR_ORIGIN = trimTrailingSlash(
  process.env.REACT_APP_OPERATOR_ORIGIN || "https://app.itruck.io",
);

const PUBLIC_HOSTS = new Set(["itruck.io", "www.itruck.io"]);

const getHostname = () => window.location.hostname.toLowerCase();

const isLocalHostname = (hostname) =>
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1" ||
  hostname.endsWith(".localhost");

const getSiteMode = () => {
  const hostname = getHostname();
  const localOverride = process.env.REACT_APP_SITE_MODE?.toLowerCase();

  if (
    isLocalHostname(hostname) &&
    (localOverride === "public" || localOverride === "operator")
  ) {
    return localOverride;
  }

  return PUBLIC_HOSTS.has(hostname) ? "public" : "operator";
};

export const isPublicHost = () => getSiteMode() === "public";

export const isOperatorHost = () => getSiteMode() === "operator";

export const getOperatorUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${OPERATOR_ORIGIN}${normalizedPath}`;
};
